<template>
   
      <div class="mod-sys__slcustomer}">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
          <el-form-item>
            <el-input v-model="dataForm.subordinateName" placeholder="下级姓名" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="dataForm.id" placeholder="下级手机号" clearable></el-input>
          </el-form-item>
     
          <el-form-item>
            <el-select  v-model="dataForm.status" filterable clearable  placeholder="下级类型">
                    <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>

          <el-form-item>
           <el-date-picker
                   v-model="date"
                   type="daterange"
                   range-separator="至"
                   start-placeholder="开始日期"
                   end-placeholder="结束日期"
                   value-format="yyyy-MM-dd"
                   @change="getTimes">
           </el-date-picker>
         </el-form-item>

          <el-form-item>
            <el-button @click="getDataList()">{{ $t('query') }}</el-button>
          </el-form-item>
          
          <!-- <el-form-item>
            <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button v-if="$hasPermission('sys:slcustomer:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button v-if="$hasPermission('sys:slcustomer:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
          </el-form-item> -->
        </el-form>
        <el-table v-loading="dataListLoading" :data="dataList" border  style="width: 100%;">
          <el-table-column prop="subordinateName" label="下级姓名" header-align="center" align="center"></el-table-column>
          <el-table-column prop="subordinateType" label="下级类型" header-align="center" align="center"></el-table-column>
          <el-table-column prop="subordinateMobile" label="下级手机号" header-align="center" align="center"></el-table-column>
          <el-table-column prop="date"  label="日期" header-align="center" align="center"></el-table-column>
          <el-table-column prop="cumulativeEntry" label="累计进件" header-align="center" align="center"></el-table-column>
          <el-table-column prop="incomingToday" label="今日进件" header-align="center" align="center"></el-table-column>
          <el-table-column prop="cumulativeLoan" label="累计放款" header-align="center" align="center"></el-table-column>
          <el-table-column prop="loanToday" label="今日放款" header-align="center" align="center"></el-table-column>
          <el-table-column prop="commissionToday" label="今日提成" header-align="center" align="center"></el-table-column>
          <el-table-column prop="cumulativeWithdrawal" label="累计提现" header-align="center" align="center"></el-table-column>
          <el-table-column prop="withdrawToday" label="今日提现" header-align="center" align="center"></el-table-column>
          
          <!-- <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
            <template slot-scope="scope">
              <el-button v-if="$hasPermission('sys:slcustomer:update')" type="text" size="small" @click="submitStatus(scope.row)">{{ scope.row.myishsow ? '完成' : '修改' }}</el-button>
              <el-button v-if="$hasPermission('sys:slcustomer:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">完成</el-button>
            </template>
          </el-table-column> -->
        </el-table>
        <el-pagination
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle">
        </el-pagination>
    
      </div>
 
  </template>
  
  <script>
  import mixinViewModule from '@/mixins/view-module'

  export default {
    mixins: [mixinViewModule],
    data () {
      return {
        mixinViewModuleOptions: {
          getDataListURL: `/sys/sluser/brokerSubordinateDetails/${this.$route.params.scopeCityId}`,
          getDataListIsPage: true,
          exportURL: '/sys/brokerSubordinateDetails/export',
          deleteURL: '/sys/brokerSubordinateDetails',
          deleteIsBatch: true
        },
        dataList: [],
        date: '',
        userTypes: [],
        statusList: [
            {
                value: '0',
                label: '直属',
            },
            {
                value: '1',
                label: '非直属',
            },
        ],
        dataForm: {
          status: '',
          subordinateName: '',
          start: '',
          end: '',
         
        }
      }
    },
  
    methods: {
      //利⽤change事件监听表单内容变化，并将选中的值赋值给所需要的两个字段
      //⽀付时间戳设置
      getTimes() {
        if (this.date != null) {
          this.dataForm.start = this.date[0]
          this.dataForm.end = this.date[1]
        }else{
          delete this.dataForm.startDate 
          delete this.dataForm.endDate
        }
      },
      //修改状态
      submitStatus(row){
        console.log(this.dataList.findIndex(item => item.id == row.id))
        let n = this.dataList.findIndex(item => item.id == row.id)
        this.$set(this.dataList,n,{...this.dataList[n],myishsow: !this.dataList[n].myishsow})
        if(row.myishsow){
          console.log(this.dataList)
        }
      },
      geteducation(v,name){
        if(name == 'userType')  return this.userTypes.filter(item => item.value == v)[0]?.label ;
        if(name == 'education') return this.educations.filter(item => item.value == v)[0]?.label ;
        if(name == 'vipLevelId') return this.vipLevels.filter(item => item.value == v)[0]?.label ;
        if(name == 'maritalStatus') return this.maritalStatus.filter(item => item.value == v)[0]?.label ;
        if(name == 'isAuth') return this.isAuth.filter(item => item.value == v)[0]?.label ;
      },
         
    
    },
  
  }
  </script>
  